import { createAction } from "redux-actions";

import { login as authLogin } from "../services/auth";
import {
  upload,
  get,
  ocr,
  extractions,
  processedPages
} from "../services/documents";
import { selectDocumentId } from "./selector";

const STATUS_PENDING = "pending";
const STATUS_PROCESSED = "processed";
const STATUS_SUCCESS = "success";
const STATUS_FAILED = "failed";

export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const UPLOAD_DOCUMENT_START = "UPLOAD_DOCUMENT_START";
export const UPLOAD_DOCUMENT_SUCCESS = "UPLOAD_DOCUMENT_SUCCESS";
export const UPLOAD_DOCUMENT_ERROR = "UPLOAD_DOCUMENT_ERROR";

export const GET_DOCUMENT_START = "GET_DOCUMENT_START";
export const GET_DOCUMENT_SUCCESS = "GET_DOCUMENT_SUCCESS";
export const GET_DOCUMENT_ERROR = "GET_DOCUMENT_ERROR";

export const GET_OCR_START = "GET_OCR_START";
export const GET_OCR_SUCCESS = "GET_OCR_SUCCESS";
export const GET_OCR_ERROR = "GET_OCR_ERROR";

export const GET_EXTRACTIONS_START = "GET_EXTRACTIONS_START";
export const GET_EXTRACTIONS_SUCCESS = "GET_EXTRACTIONS_SUCCESS";
export const GET_EXTRACTIONS_ERROR = "GET_EXTRACTIONS_ERROR";

export const GET_PROCESSED_PAGE_START = "GET_PROCESSED_PAGE_START";
export const GET_PROCESSED_PAGE_SUCCESS = "GET_PROCESSED_PAGE_SUCCESS";
export const GET_PROCESSED_PAGE_ERROR = "GET_PROCESSED_PAGE_ERROR";

export const ADD_BOUNDING_BOXES = "ADD_BOUNDING_BOXES";
export const SET_ACTIVE_BOXES = "SET_ACTIVE_BOXES";
export const ADD_LINE = "ADD_LINE";
export const REMOVE_LINES = "REMOVE_LINES";
export const SET_CURRENT_PAGE_INDEX = "SET_CURRENT_PAGE_INDEX";

export const IMAGES_LOADED = "IMAGES_LOADED";

export const setImagesLoaded = createAction(IMAGES_LOADED);

export const loginStart = createAction(LOGIN_START);
export const loginSuccess = createAction(LOGIN_SUCCESS);
export const loginError = createAction(LOGIN_ERROR);

export const uploadDocumentStart = createAction(UPLOAD_DOCUMENT_START);
export const uploadDocumentSuccess = createAction(UPLOAD_DOCUMENT_SUCCESS);
export const uploadDocumentError = createAction(UPLOAD_DOCUMENT_ERROR);

export const getDocumentStart = createAction(GET_DOCUMENT_START);
export const getDocumentSuccess = createAction(GET_DOCUMENT_SUCCESS);
export const getDocumentError = createAction(GET_DOCUMENT_ERROR);

export const getOcrStart = createAction(GET_OCR_START);
export const getOcrSuccess = createAction(GET_OCR_SUCCESS);
export const getOcrError = createAction(GET_OCR_ERROR);

export const getExtractionsStart = createAction(GET_EXTRACTIONS_START);
export const getExtractionsSuccess = createAction(GET_EXTRACTIONS_SUCCESS);
export const getExtractionsError = createAction(GET_EXTRACTIONS_ERROR);

export const getProcessedPageStart = createAction(GET_PROCESSED_PAGE_START);
export const getProcessedPageSuccess = createAction(GET_PROCESSED_PAGE_SUCCESS);
export const getProcessedPageError = createAction(GET_PROCESSED_PAGE_ERROR);

export const addBoundingBoxes = createAction(ADD_BOUNDING_BOXES);
export const setActiveBoxes = createAction(SET_ACTIVE_BOXES);
export const addLine = createAction(ADD_LINE);
export const removeLines = createAction(REMOVE_LINES);
export const setCurrentPageIndex = createAction(SET_CURRENT_PAGE_INDEX);

export const login = () => async (dispatch) => {
  dispatch(loginStart());

  try {
    const { data } = await authLogin();
    const { access_token, token_type } = data;

    localStorage.setItem("accessToken", access_token);
    localStorage.setItem("tokenType", token_type);

    dispatch(
      loginSuccess({ accessToken: access_token, tokenType: token_type })
    );
  } catch (error) {
    dispatch(loginError);
  }
};

export const uploadDocument = (document) => async (dispatch) => {
  dispatch(uploadDocumentStart());

  try {
    const { data } = await upload(document);
    dispatch(uploadDocumentSuccess({ documentId: data.uuid }));
    dispatch(getDocument());
  } catch (error) {
    dispatch(uploadDocumentError(error));
  }
};

export const getDocument = () => async (dispatch, getState) => {
  const documentId = selectDocumentId(getState());
  dispatch(getDocumentStart());

  const { data } = await get(documentId);
  const { document_type, processing_status } = data;

  if (processing_status === STATUS_PENDING) {
    setTimeout(() => dispatch(getDocument()), 2000);
  }

  if (
    processing_status === STATUS_PROCESSED ||
    processing_status === STATUS_SUCCESS
  ) {
    dispatch(getDocumentSuccess({ documentType: document_type }));
    dispatch(getOcr());
    dispatch(getExtractions());
    dispatch(getProcessedPage());
  }

  if (processing_status === STATUS_FAILED) {
    dispatch(getDocumentError());
  }
};

export const getOcr = () => async (dispatch, getState) => {
  const documentId = selectDocumentId(getState());
  dispatch(getOcrStart());
  try {
    const { data } = await ocr(documentId);
    const { pages } = data;
    const byPage = {};

    pages.forEach((page, pageIndex) => {
      byPage[pageIndex] = [];
      page.bboxes.forEach((bbox) => {
        byPage[pageIndex].push(bbox);
      });
    });

    dispatch(getOcrSuccess());
    dispatch(addBoundingBoxes({ byPage }));
  } catch (error) {
    console.log(error);

    dispatch(getOcrError(error));
  }
};

export const getExtractions = () => async (dispatch, getState) => {
  const documentId = selectDocumentId(getState());
  dispatch(getExtractionsStart());
  try {
    const { data } = await extractions(documentId);

    dispatch(getExtractionsSuccess(data));
  } catch (error) {
    dispatch(getExtractionsError(error));
  }
};

export const getProcessedPage = () => async (dispatch, getState) => {
  const documentId = selectDocumentId(getState());
  dispatch(getProcessedPageStart());
  try {
    const { data } = await processedPages(documentId);

    dispatch(getProcessedPageSuccess(data));
  } catch (error) {
    console.log(error);

    dispatch(getProcessedPageError(error));
  }
};
